export const PMSPropertyTree = 'PropertyTree.com'
